<div class="crc-root"
	 [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

	<connex-route-edit-drawer #routeDrawer
							  [canCreateRoute]="canCreateRoute"
							  [canUpdateRoute]="canUpdateRoute"
							  (saved)="onRouteDrawerSaved()"></connex-route-edit-drawer>

	<div class="crc-shell">
		<p-tabMenu class="crc-config-tabs"
				   [model]="configTabItems"
				   [activeItem]="activeConfigTab"
				   (activeItemChange)="onConfigTabChange($event)"></p-tabMenu>

		<div class="crc-card" *ngIf="activeConfigTabId === 'routes'">
			<div class="crc-card__table">
				<div *ngIf="!showRouteTableShell()"
					 class="crc-card__header-wrap">
					<div class="crc-card__rule"></div>
					<div class="crc-card__header">
						<div class="crc-card__titles">
							<h1 class="crc-card__title">Route Configuration</h1>
							<p class="crc-card__desc">
								Configure routes, departure slots, fares and inventory shown in the ConneX Customer App.
							</p>
						</div>
						<div class="crc-card__header-actions">
							<button pButton
									type="button"
									label="Bulk Upload"
									class="p-button-outlined crc-btn-bulk"
									[disabled]="true"
									[attr.title]="'Coming in a later release'"></button>
							<button pButton
									*ngIf="canCreateRoute"
									type="button"
									icon="pi pi-plus"
									label="Create Route"
									class="crc-btn-create"
									(click)="onCreateRoute()"></button>
						</div>
					</div>
					<div class="crc-card__rule"></div>
				</div>

				<div class="crc-card__body">
					<div *ngIf="loading && !hasLoaded"
						 class="crc-loading">
						<p-progressSpinner strokeWidth="4"
										   animationDuration=".8s"></p-progressSpinner>
					</div>

					<div *ngIf="hasLoaded && totalRecords === 0 && !hasActiveSlotFilters() && !showRouteTableShell()"
						 class="crc-empty">
						<div class="crc-empty__icon-wrap">
							<img [src]="emptyIllustrationSrc"
								 width="64"
								 height="64"
								 alt=""
								 class="crc-empty__img" />
						</div>
						<div class="crc-empty__text-block">
							<p class="crc-empty__title">No routes configured yet</p>
							<p class="crc-empty__body">
								ConneX routes appear here once created. Customers won't see ConneX bookings until at least one active route exists.
							</p>
						</div>
						<button pButton
								*ngIf="canCreateRoute"
								type="button"
								icon="pi pi-plus"
								label="Create Route"
								class="crc-btn-create crc-btn-create--tall"
								(click)="onCreateRoute()"></button>
					</div>

					<div *ngIf="showRouteTableShell()"
						 class="crc-table-wrap">
						<p-table [value]="routes"
								 [lazy]="true"
								 (onLazyLoad)="onRouteTableLazyLoad($event)"
								 [paginator]="true"
								 [(first)]="first"
								 [rows]="rows"
								 [totalRecords]="totalRecords"
								 [loading]="loading"
								 [scrollable]="true"
								 [scrollHeight]="tableBodyScrollHeight"
								 [showCurrentPageReport]="true"
								 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
								 paginatorStyleClass="paginator-left"
								 [tableStyle]="{ 'min-width': '128rem' }"
								 styleClass="crc-slot-table p-datatable-sm"
								 dataKey="RouteId">
							<ng-template pTemplate="caption">
								<div class="crc-table-caption">
									<div class="crc-table-caption__rule"></div>
									<div class="crc-table-caption__bar">
										<div class="crc-table-caption__titles">
											<h2 class="crc-card__title">Route Configuration</h2>
											<p class="crc-card__desc">
												Configure routes, departure slots, fares and inventory shown in the ConneX Customer App.
											</p>
										</div>
										<div class="crc-table-caption__actions">
											<button pButton
													type="button"
													label="Bulk Upload"
													class="p-button-outlined crc-btn-bulk"
													[disabled]="true"
													[attr.title]="'Coming in a later release'"></button>
											<button pButton
													*ngIf="canCreateRoute"
													type="button"
													icon="pi pi-plus"
													label="Create Route"
													class="crc-btn-create"
													(click)="onCreateRoute()"></button>
										</div>
									</div>
									<div class="crc-table-caption__rule"></div>
								</div>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="RouteName"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Route Name</span>
											<p-sortIcon field="RouteName" />
										</div>
									</th>
									<th pSortableColumn="DirectionCount"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Direction</span>
											<p-sortIcon field="DirectionCount" />
										</div>
									</th>
									<th pSortableColumn="PickupZonesSummary"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Pickup Zones</span>
											<p-sortIcon field="PickupZonesSummary" />
										</div>
									</th>
									<th pSortableColumn="DropoffZonesSummary"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Drop-off Zones</span>
											<p-sortIcon field="DropoffZonesSummary" />
										</div>
									</th>
									<th pSortableColumn="SlotCount"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Slot</span>
											<p-sortIcon field="SlotCount" />
										</div>
									</th>
									<th pSortableColumn="FareRangeMin"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Fare Range</span>
											<p-sortIcon field="FareRangeMin" />
										</div>
									</th>
									<th pSortableColumn="BookingWindowMinMinutes"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Booking</span>
											<p-sortIcon field="BookingWindowMinMinutes" />
										</div>
									</th>
									<th pSortableColumn="PremiumFareMin"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Walk-In</span>
											<p-sortIcon field="PremiumFareMin" />
										</div>
									</th>
									<th pSortableColumn="Status"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Status</span>
											<p-sortIcon field="Status" />
										</div>
									</th>
									<th pSortableColumn="LastUpdatedAt"
										class="crc-th">
										<div class="crc-th__inner">
											<span>Updated</span>
											<p-sortIcon field="LastUpdatedAt" />
										</div>
									</th>
									<th class="crc-th crc-th--no-sort">
										<div class="crc-th__inner">
											<span>Updated By</span>
										</div>
									</th>
									<th class="crc-th crc-th--no-sort crc-col-actions">
										<div class="crc-th__inner">
											<span>Action</span>
										</div>
									</th>
								</tr>
								<tr class="crc-filter-row">
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.routeName"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.direction"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.pickup"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.dropoff"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.slot"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="—"
											   [disabled]="true"
											   tabindex="-1" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.booking"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.walkIn"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.status"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="Type here"
											   [(ngModel)]="slotHeaderFilters.updatedAt"
											   (input)="handleHeaderFilterChange()" />
									</th>
									<th class="overflow-unset">
										<input type="text"
											   pInputText
											   class="w-full"
											   placeholder="—"
											   [disabled]="true"
											   tabindex="-1" />
									</th>
									<th class="crc-col-actions crc-filter-row__empty"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body"
										 let-row>
								<tr>
									<td class="crc-td crc-td--route">
										<div class="crc-route-cell-inner">
											<span class="crc-route-name">{{ row.RouteName }}</span>
										</div>
									</td>
									<td class="crc-td">{{ directionCountLabel(row.DirectionCount) }}</td>
									<td class="crc-td crc-td-ellipsis">{{ row.PickupZonesSummary }}</td>
									<td class="crc-td crc-td-ellipsis">{{ row.DropoffZonesSummary }}</td>
									<td class="crc-td">{{ slotCountLabel(row.SlotCount) }}</td>
									<td class="crc-td crc-td--money">{{ fareRangeLabel(row) }}</td>
									<td class="crc-td">{{ bookingLabel(row) }}</td>
									<td class="crc-td crc-td--money">{{ walkInLabel(row) }}</td>
									<td class="crc-td">
										<p-tag [value]="(row.Status || '').trim() || '—'"
											   [severity]="connexRouteStatusSeverity(row.Status)"></p-tag>
									</td>
									<td class="crc-td">{{ updatedLabel(row) }}</td>
									<td class="crc-td">{{ updatedByLabel(row) }}</td>
									<td class="crc-td crc-col-actions">
										<div class="crc-actions-cell">
											<button pButton
													type="button"
													icon="pi pi-eye"
													label="View"
													class="p-button-text p-button-sm crc-btn-view"
													(click)="onViewRoute(row.RouteId)"></button>
											<button pButton
													*ngIf="canUpdateRoute"
													type="button"
													icon="pi pi-pencil"
													label="Edit"
													class="p-button-sm crc-btn-edit"
													(click)="onEditRoute(row.RouteId)"></button>
										</div>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="13">{{ hasActiveSlotFilters() ? 'No routes match the current filters.' : 'No data' }}</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</div>
			</div>
		</div>

		<connex-assigning-drivers-tab *ngIf="activeConfigTabId === 'assigning-drivers'"
									  [menuPermissionActive]="menuPermissionActive"></connex-assigning-drivers-tab>
	</div>
</div>
